import { cva } from '@/styled-system/css';

export const chipGroupRecipe = cva({
  base: {
    display: 'flex',
    columnGap: 'ChipGroup.gap.horz',
    flexWrap: 'wrap',
  },
  variants: {
    verticalSpacing: {
      default: {
        rowGap: 'ChipGroup.gap.vert.default',
      },
      tighter: {
        rowGap: 'ChipGroup.gap.vert.tighter',
      },
    },
  },
});
